/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".info-parecer[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;word-break:break-all}.desc-parecer[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;word-break:break-all;padding:1em 0}.item-motivo[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;text-transform:uppercase}"];
export { styles as styles };
